import { deleteMassEquipments } from '@services/queries/equipments';
import { UseMutationResult } from 'react-query';
import { Context } from '@store/machines/equipmentsPicker.schema';
import { IEquipmentInventory } from '@models/EquipmentInventory.model';
import { trackAssetsDeleted } from '@services/mixpanel/trackers/AssetMetrics';
import { noop } from '@utils/noop';

type DeleteMassEquipmentsMutation = UseMutationResult<
  void,
  unknown,
  Parameters<typeof deleteMassEquipments>['0'],
  unknown
>;
export function onDeleteEquipments(
  context: Context,
  deleteMassEquipmentsMutation: DeleteMassEquipmentsMutation,
): () => void {
  return () => {
    const ids = Array.from(context.data.values(), equipment => equipment.id);
    deleteMassEquipmentsMutation
      .mutateAsync({
        ids,
      })
      .finally(() => {
        // Included mixpanel stuff here
        const productNames = new Set<string>();
        const productModels = new Set<string>();
        const manufacturers = new Set<string>();
        context.data.forEach(equipment => {
          const typedEquipment = equipment as IEquipmentInventory;
          const { product, manufacturerName } = typedEquipment;
          if (product.name) productNames.add(product.name);
          if (product.model) productModels.add(product.model);
          if (manufacturerName) manufacturers.add(manufacturerName);
        });
        const productNamesArr = Array.from(productNames.values());
        const productModelsArr = Array.from(productModels.values());
        const manufacturersArr = Array.from(manufacturers.values());

        trackAssetsDeleted(
          productNamesArr,
          productModelsArr,
          manufacturersArr,
          ids,
        );
      })
      .catch(noop);
  };
}
